import { SCOPE } from '../../../shared/constants';
import { toFormFieldText } from '../../../shared/utils/formValue';
import { SCOPE_2_APPLICATION } from '../../office/model/scope2Assignment';

export const EMPTY_EMISSION_FACTOR_FORM = {
  scope: SCOPE.SCOPE_1,
  category: 'GASOLINE',
  sub_category: '',
  fiscal_year: '2025',
  ef_name: '',
  ef_external_id: '',
  ef_value: '',
  ef_unit: '',
  ef_company_core: '',
  supplier_id: '',
  application_code: SCOPE_2_APPLICATION.CORPORATE_AVERAGE_REFERENCE,
};

const supplierIdFor = (doc, suppliers) => {
  const explicitId = doc?.supplier_id || doc?.supplier_ref_id;
  if (explicitId) return explicitId;
  return suppliers.find(supplier => (
    supplier.registrationNo === doc?.registration_no
  ))?.id || '';
};

export function toEmissionFactorForm(doc, suppliers = []) {
  if (!doc) return { ...EMPTY_EMISSION_FACTOR_FORM };
  return {
    scope: doc.scope || SCOPE.SCOPE_1,
    category: doc.category || 'GASOLINE',
    sub_category: toFormFieldText(doc.sub_category),
    fiscal_year: toFormFieldText(doc.fiscal_year),
    ef_name: toFormFieldText(doc.ef_name),
    ef_external_id: toFormFieldText(doc.ef_external_id),
    ef_value: toFormFieldText(doc.ef_value),
    ef_unit: toFormFieldText(doc.ef_unit),
    ef_company_core: toFormFieldText(doc.ef_company_core),
    supplier_id: supplierIdFor(doc, suppliers),
    application_code: doc.application_code
      || SCOPE_2_APPLICATION.CORPORATE_AVERAGE_REFERENCE,
  };
}

export function toEmissionFactorPayload(values) {
  const commonPayload = {
    scope: values.scope,
    effective_year: Number(values.fiscal_year),
    // Decimal stays text end-to-end. Number(...) would silently lose precision.
    factor_value: values.ef_value.trim(),
  };
  if (values.scope === SCOPE.SCOPE_2) {
    return {
      ...commonPayload,
      supplier_id: values.supplier_id,
    };
  }
  return {
    ...commonPayload,
    category: values.category,
    sub_category: values.sub_category || null,
    business_name: values.ef_name.trim(),
    source_external_id: values.ef_external_id.trim() || null,
    factor_unit: values.ef_unit.trim(),
  };
}

export function manualFactorSourceRef(existing, uploadedSource) {
  return uploadedSource?.id || existing?.source_file?.id || null;
}
